var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasSlotDefault)?_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }